import { render, staticRenderFns } from "./Assess.vue?vue&type=template&id=7bd5b502&scoped=true"
import script from "./Assess.vue?vue&type=script&lang=js"
export * from "./Assess.vue?vue&type=script&lang=js"
import style0 from "./Assess.vue?vue&type=style&index=0&id=7bd5b502&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bd5b502",
  null
  
)

export default component.exports